/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';

import './../styles/styles.css';
import { Handler } from '../common/handler';
import { PlayButton } from './PlayButton';
import FullNote from '../assets/icons/full-note.svg';
import FullNoteActive from '../assets/icons/full-note-active.svg';
import HalfNote from '../assets/icons/half-note.svg';
import HalfNoteActive from '../assets/icons/half-note-active.svg';
import QuarterNote from '../assets/icons/quarter-note.svg';
import QuarterNoteActive from '../assets/icons/quarter-note-active.svg';
import ChordNote from '../assets/icons/chord.svg';
import SaveButton from './buttons/SaveButton';
import ChordShiftButton from './buttons/ChordShiftButton';
import ChordDirectionButton from './buttons/ChordDirectionButton';
import { SharpButtons } from './buttons/SharpButtons';
import { Toast } from 'antd-mobile';
import { doPostMessage } from '../utils/rn';

const noteIcons = {
    full: {
        normal: FullNote,
        active: FullNoteActive,
    },
    half: {
        normal: HalfNote,
        active: HalfNoteActive,
    },
    quarter: {
        normal: QuarterNote,
        active: QuarterNoteActive,
    },
};

interface TopNavBarProps {
    title: string;
    pickNote: (note: string | null) => void;
    handler: Handler | null;
    showChordPopup: () => void;
    touched: boolean;
    isMember: boolean;
    uuid: string | null;
    onSuccess: (data: any) => void;
}

type WindowWithReactNativeWebView = Window & {
    ReactNativeWebView: {
        postMessage: (message: string) => void;
    };
};

function TopNavBar({ title, pickNote, handler, showChordPopup, touched, isMember,uuid, onSuccess }: TopNavBarProps) {
    const [activeNote, setActiveNote] = useState<string | null>('quarter');
    const [dialog, setDialog] = useState<string>('');
    const [isWebView, setIsWebView] = useState(false);

    useEffect(() => {
        pickNote(activeNote);
    }, []);

    useEffect(() => {
        const checkIfWebView = (): void => {
            if ((window as any).ReactNativeWebView && typeof (window as any).ReactNativeWebView.postMessage === 'function') {
                setIsWebView(true);
            }
        };

        checkIfWebView();
    }, []);

    useEffect(() => {
        setDialog('');
    }, [touched]);

    useEffect(() => {
        pickNote(activeNote);
    }, [activeNote]);

    const selectNote = (note: String | null) => {
        if (note === activeNote) {
            setActiveNote(null);
            return;
        }

        switch (note) {
            case 'full':
                setActiveNote('full');
                break;
            case 'half':
                setActiveNote('half');
                break;
            case 'quarter':
                setActiveNote('quarter');
                break;
            default:
                setActiveNote(null);
        }
    };

    const NoteButton = ({
        noteIcon,
        name,
        isActive = false,
        callback = () => { },
    }: {
        noteIcon: { active: any; normal: any };
        name: string;
        isActive: boolean;
        callback: () => void;
    }) => {
        return (
            <button
                className="note"
                onClick={() => {
                    selectNote(name);
                    callback();
                }}
            >
                <img src={isActive ? noteIcon.active : noteIcon.normal} width={30} height={30} alt="" />
            </button>
        );
    };

    const ChordButton = () => {
        return (
            <button className="right-button" onClick={showChordPopup}>
                <img src={ChordNote} alt="chord-button" />
            </button>
        );
    };

    const handleClick = (message: any): void => {
        // 仅当确认在WebView环境中时才调用postMessage
        if (isWebView) {
            (window as unknown as WindowWithReactNativeWebView).ReactNativeWebView.postMessage(message);
        } else {
            console.log('This is not a React Native WebView environment.');
        }
    };

    return (
        <div className="top-nav-bar">
            <div className="left-buttons">
                <button
                    type="button"
                    onClick={() => {
                        doPostMessage({}, 'close-editor');
                        handleClick(JSON.stringify({ close: true }));
                    }}
                >
                    <img src={require('../assets/icons/arrow-left-line.png')} alt="arrow-left-line" />
                </button>
                <h3 className="new-title">{title}</h3>
                <PlayButton handler={handler} />
            </div>
            <div className="center-buttons">
                <NoteButton
                    noteIcon={noteIcons.full}
                    name="full"
                    isActive={activeNote === 'full'}
                    callback={() => {
                        setActiveNote('full');
                    }}
                />
                <NoteButton
                    noteIcon={noteIcons.half}
                    isActive={activeNote === 'half'}
                    name="half"
                    callback={() => {
                        setActiveNote('half');
                    }}
                />
                <NoteButton
                    noteIcon={noteIcons.quarter}
                    name="quarter"
                    isActive={activeNote === 'quarter'}
                    callback={() => {
                        setActiveNote('quarter');
                    }}
                />
                <SharpButtons handler={handler} />
            </div>
            <div className="right-buttons">
                <ChordDirectionButton
                    showDialog={dialog === 'chord-direction'}
                    onClick={() => {
                        if (!isMember) {
                            Toast.show({
                                icon: 'fail',
                                content: '开通会员享用功能',
                            });
                        } else {
                            setDialog('chord-direction');
                        }
                    }}
                    handler={handler}
                    isMember={isMember}
                />
                <ChordShiftButton
                    showDialog={dialog === 'chord-shift'}
                    onClick={() => {
                        if (!isMember) {
                            Toast.show({
                                icon: 'fail',
                                content: '开通会员享用功能',
                            });
                        } else {
                            setDialog('chord-shift');
                        }
                    }}
                    handler={handler}
                    isMember={isMember}
                />
                <ChordButton />
                <SaveButton uuid={uuid} title={title} handler={handler} onSuccess={onSuccess} />
            </div>
        </div>
    );
}

export default TopNavBar;
